import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '爆料分类',
    links: [
      { label: '网红黑料', href: '/category/wanghong-heliao' },
      { label: '明星塌房', href: '/category/mingxing-tafang' },
      { label: '博主爆料', href: '/category/bozhu-baoliao' },
      { label: '综艺吃瓜', href: '/category/zongyi-chigua' },
      { label: '影视揭秘', href: '/category/dianshi-juqing' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系方式', href: '/about#contact' },
      { label: '用户口碑', href: '/about#testimonials' },
    ],
  },
  {
    title: '法律声明',
    links: [
      { label: '隐私政策', href: '/about' },
      { label: '免责声明', href: '/about' },
      { label: '举报通道', href: '/about#contact' },
    ],
  },
];

const socialLinks = [
  { icon: 'ri-weibo-line', label: '微博', href: '#' },
  { icon: 'ri-wechat-line', label: '微信', href: '#' },
  { icon: 'ri-tiktok-line', label: '抖音', href: '#' },
  { icon: 'ri-bilibili-line', label: 'B站', href: '#' },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-18">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block">
              <span className="font-heading text-3xl md:text-4xl font-bold text-background-50 tracking-tight">
                五一黑料网
              </span>
            </Link>
            <p className="mt-5 text-sm text-background-300 leading-relaxed max-w-sm">
              五一黑料网官网直达入口，聚合各类网红黑料、明星塌房现场及博主爆料内容。持续收录最新八卦猛料，无需下载即可快速获取网站一手黑料资讯。
            </p>
            <div className="flex items-center gap-3 mt-6">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-9 h-9 rounded-full border border-background-700 flex items-center justify-center text-background-300 hover:text-background-50 hover:border-background-50 transition-colors duration-200"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-xs font-semibold uppercase tracking-widest text-background-400 mb-5">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-300 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 五一黑料网 版权所有 | 本网站内容仅供娱乐参考，请理性看待
          </p>
          <div className="flex items-center gap-5">
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap">
              关于我们
            </Link>
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap">
              隐私政策
            </Link>
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 whitespace-nowrap">
              免责声明
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}